import React from 'react';
import Slider from "react-slick";

// Import required CSS for the slider
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

// Import your project's custom CSS if needed for this component
import '../../assets/css/style.css'; 

// Import all the feature images needed for this section
// IMPORTANT: Adjust the path ('../../') based on where you save this new file.
import feature01 from '../../assets/img/features/feature-01.jpg';
import feature02 from '../../assets/img/features/feature-02.jpg';
import feature03 from '../../assets/img/features/feature-03.jpg';
import feature04 from '../../assets/img/features/feature-04.jpg';
import feature05 from '../../assets/img/features/feature-05.jpg';
import feature06 from '../../assets/img/features/feature-06.jpg';
import feature07 from '../../assets/img/facility.png';

const AvailableFeatures = () => {
    // Array of imported images for the slider
    const items = [feature01, feature02, feature07, feature03, feature04, feature05, feature06];

    // Configuration settings for the react-slick slider
    const featureSliderSettings = {
        infinite: true,
        speed: 500,
        slidesToShow: 6,
        slidesToScroll: 1,
        autoplay: false, // Set to true if you want autoplay
        arrows: false,
        centerMode: true,
        responsive: [
            {
                breakpoint: 992,
                settings: {
                    slidesToShow: 3,
                },
            },
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 2,
                },
            },
            {
                breakpoint: 576,
                settings: {
                    slidesToShow: 1,
                },
            },
        ],
    };

    return (
        <section className="section section-features">
            <div className="container-fluid">
                <div className="row">
                    <div className="col-md-12">
                        <div className="section-header text-center">
                            <h2 className="mt-2">Available Features in Our Hospital</h2>
                            <p>
                                Where advanced care meets personalized treatment, dedicated to your health and well-being.
                            </p>
                        </div>
                        <Slider {...featureSliderSettings} className="feature-slider-wrapper">
                            {items.map((item, index) => (
                                <div key={index} className="feature-item text-center" style={{ border: 'none' }}>
                                    <img
                                        src={item}
                                        alt="Clinic Feature"
                                        className="img-fluid"
                                    />
                                   <a href='/facilities'> <p>
                                        {/* Logic to display the correct text for each image */}
                                        {item === feature01 ? 'Patient Ward' :
                                            item === feature02 ? 'Test Room' :
                                                item === feature07 ? 'X-Ray' :
                                                    item === feature03 ? 'ICU' :
                                                        item === feature04 ? 'Laboratory' :
                                                            item === feature05 ? 'Operation' :
                                                                item === feature06 ? 'Medical' : ''
                                        }
                                    </p></a>
                                </div>
                            ))}
                        </Slider>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default AvailableFeatures;